import MediaQuery from 'react-responsive'

export const Mobile = ({ maxWidth = 767, ...rest }) => (
  <MediaQuery {...rest} maxWidth={maxWidth} />
)
export const SmallDesktop = ({ maxWidth = 1280, ...rest }) => (
  <MediaQuery {...rest} maxWidth={maxWidth} />
)
export const Desktop = ({ minWidth = 768, ...rest }) => (
  <MediaQuery {...rest} minWidth={minWidth} />
)
